import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectUserIsIdentified } from 'core/selectors/user';
import { selectStoreCount, selectExtraRewardsPage } from 'core/selectors/app';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import Countdown from 'core/modules/Countdown/Countdown';
import { useGetBonusOffers } from 'core/modules/BonusOffers/hooks';
import { checkIfUrlPointsToExtraRewards } from 'core/utils/helpers';
import { convertDateTimeToETTimezone } from 'core/utils/helpers/date';
import { addCommas } from 'core/utils/helpers/numbers';

import { parseBonusTrackerOffer } from 'core/modules/BonusTracker/utils/parseBonusTrackerOffer';
import { triggerPublicBonusTrackerIsViewed } from './actions';
import PublicBonusIndicator from './components/PublicBonusIndicator';

import './PublicBonusTracker.scss';

function PublicBonusTracker() {
  const dispatch = useDispatch();
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const { publicAutomaticOffersToShow } = useGetBonusOffers();
  const storeCount = useSelector(selectStoreCount);
  const [shouldShowCountDown, setShouldShowCountDown] = useState(false);
  const publicAutomaticBonus = publicAutomaticOffersToShow[0];
  const extraRewardsPage = useSelector(selectExtraRewardsPage);
  const isExtraRewardsPage = checkIfUrlPointsToExtraRewards(window.location.href, extraRewardsPage);
  const shouldShowAutomaticPublicBonus = publicAutomaticBonus?.isAutomaticPlacement && isExtraRewardsPage;

  const {
    bonusName, brandCurrency, startDate,
    endDate, isEnded,
  } = parseBonusTrackerOffer(publicAutomaticBonus);

  const countDownCompleteHandler = () => setShouldShowCountDown(false);

  useEffect(() => {
    setShouldShowCountDown(!isEnded);
    dispatch(triggerPublicBonusTrackerIsViewed(publicAutomaticBonus.id));
  }, []);

  if (!shouldShowAutomaticPublicBonus) {
    return null;
  }

  const { offers } = publicAutomaticBonus;
  const offer = offers[0];
  const { maxRewardAvailable, minSpendToQualify } = offer;

  const endDateETTimeZone = convertDateTimeToETTimezone(endDate);
  const formattedFullEndDate = endDateETTimeZone.format('M/DD/YYYY');

  return (
    <div className={`mn_publicAutomaticBonusTracker mn_bonusItem ${userIsIdentified ? '' : 'mn_anonymous'}`}>
      {shouldShowCountDown &&
        <div className="mn_titleWrap">
          <div className="mn_title">
            {bonusName}:
            <Countdown
              startDate={startDate}
              endDate={endDate}
              onComplete={countDownCompleteHandler}
              donotUseLeadingZeroInDays
            />
          </div>
        </div>
      }
      <div className="mn_info">
        <div className="mn_description">
          <h2>
            Earn {addCommas(maxRewardAvailable)} bonus {brandCurrency} when you
            spend {addCommas(minSpendToQualify)} or more by {formattedFullEndDate}*
          </h2>
          <div className="mn_disclaimer">Shop and earn at {storeCount}+ stores</div>
        </div>
        <PublicBonusIndicator publicAutomaticBonus={publicAutomaticBonus} offer={offer} />
      </div>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><PublicBonusTracker {...props} /></ComponentErrorBoundary>;
